export const ROUTE_NAMES = {
	SZEMELYES: '/szemelyes',
	KARTYAESSZAMLA: '/kartyaesszamla',
	KARTYAKEP: '/kartyakep',
	OSSZEGZES: '/osszegzes',
	KOSZONJUK: '/koszonjuk'
};
export const PROVIDER_PREFIXES = {
	30: 'MT',
	20: 'TN',
	70: 'VF',
	31: 'TS',
	50: 'DG'
};
export const HEADER_HEIGHT = 92;
export const SUMMARY_HEADER_HEIGHT = 12;
export const OKI_PAGES = [
	{
		text: 'Személyes adatok',
		link: ROUTE_NAMES.SZEMELYES
	},
	{
		text: 'Kártya és számla adatok',
		link: ROUTE_NAMES.KARTYAESSZAMLA
	},
	{
		text: 'Összegzés',
		link: ROUTE_NAMES.OSSZEGZES
	}
];

let tempArray = [...OKI_PAGES];

tempArray.splice(2, 0, {
	text: 'Kártyakép feltöltés',
	link: ROUTE_NAMES.KARTYAKEP
});
export const SOKI_PAGES = [...tempArray];

export const DEBUG = false;
